import React, { useState, useEffect } from 'react';
import { StackShim as Stack, StackItemShim as StackItem } from '@fluentui/react-migration-v8-v9';
import {
  Field,
  Input,
  Select,
  Label,
  FluentProvider,
  webLightTheme,
} from '@fluentui/react-components';
import { useQuery, ApolloError } from '@apollo/client';
import { StatUser } from '../../utils/statApi/UsersApi';
import { sideBySideWrapper, sideBySideFormFieldsClassName } from './UsersStyles';
import GET_ROLES_QUERY, { Role } from '../../utils/statApi/RolesApi';
import SpanWithLabel from '../common/SpanWithLabel';
import momentUtc from '../../utils/DateFormatter';
import StatDateFormats from '../../utils/types/DateFormats';
import IDropdownOption from '../../utils/types/IDropdownOption';

interface IPrimaryFormFieldProps {
  statUser: StatUser;
  userRole: number;
  alias: string;
  onSetUserRole: (roleId: number) => void;
}

const PrimaryFormFields = (props: IPrimaryFormFieldProps): JSX.Element => {
  const { statUser, userRole, alias, onSetUserRole } = props;
  const {
    error,
    loading,
    data,
  }: { error?: ApolloError; loading: boolean; data: { role: Role[] } } = useQuery(GET_ROLES_QUERY);

  const status = statUser.isActive ? 'Active' : 'Deactivated';
  const userLastLoginDate = momentUtc(statUser.lastLoginDate, StatDateFormats.DaySimple, true);

  const selectedRole = userRole;
  const [userRoles, setUserRoles] = useState([]);

  useEffect(() => {
    if (!loading && !error && data) {
      const options: IDropdownOption[] = data.role.map((role) => {
        return { key: role.id, text: role.name };
      });
      options.unshift({ key: null, text: '--' });
      setUserRoles(options);
    }
  }, [loading]);

  return (
    <FluentProvider theme={webLightTheme}>
      <Stack horizontal wrap tokens={sideBySideWrapper}>
        <StackItem className={sideBySideFormFieldsClassName}>
          <Field label="User Alias">
            <Input id="alias" defaultValue={alias} disabled />
          </Field>
        </StackItem>
        <StackItem className={sideBySideFormFieldsClassName}>
          <Field label="Status">
            <Input id="isActive" defaultValue={status} disabled />
          </Field>
        </StackItem>
        <StackItem className={sideBySideFormFieldsClassName}>
          <Label id="globalRoleSelect">Global Role</Label>
          <Select
            aria-labelledby="globalRoleSelect"
            value={selectedRole?.toString() || ''}
            onChange={(event: React.ChangeEvent<HTMLSelectElement>): void => {
              const selectedValue = event.target.value;
              onSetUserRole(selectedValue === '' ? null : Number(selectedValue));
            }}
            required
          >
            <option value="">Select a role</option>
            {userRoles.map((option) => (
              <option key={option.key} value={option.key}>
                {option.text}
              </option>
            ))}
          </Select>
        </StackItem>
        <StackItem className={sideBySideFormFieldsClassName}>
          <SpanWithLabel labelText="Last Login:" value={userLastLoginDate} />
        </StackItem>
      </Stack>
    </FluentProvider>
  );
};
export default PrimaryFormFields;
